(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt-Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips}`;
  }

  const habits = {
    'coffee':        'For your coffee',
    'tv':            'For nights like this',
    'bedside-table': 'You kept one back',
    'sofa':          'This is the plan',
    'after-dinner':  'Best saved for last',
  };

  const habitImages = {
    'coffee': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-Coffee-Hazelnut-PDP.png?v=1775637624',
      'smaltz':       null,
    },
    'tv': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-TVNoisey-PDP.png?v=1775742716',
      'smaltz':       null,
    },
    'bedside-table': {
      'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-BedsideTable-Caramel.png?v=1775665704',
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'sofa': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'after-dinner': {
      'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Screenshot_2026-04-10_at_17.37.56.png?v=1775839085',
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
  };

  const flavourKeys = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt-Cornflakes',
  };

  Object.entries(habits).forEach(([habit, subline1]) => {
    Object.entries(flavourKeys).forEach(([flavourKey, flavourLabel]) => {
      const key = `habit-${habit}-${flavourKey}`;
      window.adConfigs[key] = {
        subline1,
        subline2: buildFlavourChips(flavourLabel),
        cartSub:  buildFlavourList(flavourLabel),
        image:    habitImages[habit][flavourKey],
      };
    });
  });
})();